import C from "../constants";

export default function clientMiddleware(apiClient) {
  return ({ dispatch, getState }) => {
    return (next) => (action) => {
      if (typeof action === "function") {
        return action(dispatch, getState);
      }

      const { promise, types, ...rest } = action;
      if (!promise) {
        const { auth } = getState();
        if (auth.token) {
          apiClient.token = auth.token;
          return apiClient.put(`/api/users/${auth.user.id}`).then(
            (res) => {
              if (res.status === 201 && res.token) {
                const storedState = JSON.parse(
                  window.localStorage.getItem(C.APP_NAME)
                );
                storedState.auth.token = res.token;
                window.localStorage.setItem(
                  C.APP_NAME,
                  JSON.stringify(storedState)
                );
                if (rest.type === "@@router/UPDATE_PATH") {
                  storedState.router.path = rest.payload.path;
                }
                next({ ...rest, payload: storedState, type: C.RESET_STATE });
              } else {
                next(action);
              }
            },
            (error) => {
              if (error.status === 401) {
                if (error.message === "Session has expired") {
                  next({ ...rest, error, type: "SESSION_EXPIRED" });
                } else {
                  next({ ...rest, error, type: "NOT_AUTHORIZED" });
                }
              } else {
                next({ ...rest, error, type: FAILURE });
              }
            }
          );
        } else {
          return next(action);
        }
      }

      const [REQUEST, SUCCESS, FAILURE] = types;
      const { auth } = getState();
      next({ ...rest, type: REQUEST });
      apiClient.token = auth.token;
      return promise(apiClient)
        .then(
          (result) => {
            if (auth.token) {
              if (!auth.user || !auth.user.id) {
                auth.user = result.user;
              }
              return apiClient.put(`/api/users/${auth.user.id}`).then(
                (res) => {
                  if (res.status === 201 && res.token) {
                    const storedState = JSON.parse(
                      window.localStorage.getItem(C.APP_NAME)
                    );
                    storedState.auth.token = res.token;
                    window.localStorage.setItem(
                      C.APP_NAME,
                      JSON.stringify(storedState)
                    );
                    next({
                      ...rest,
                      payload: storedState,
                      type: C.RESET_STATE,
                    }); // fix it
                  } else {
                    next({ ...rest, result, type: SUCCESS });
                  }
                },
                (error) => {
                  if (error.status === 401) {
                    if (error.message === "Session has expired") {
                      next({ ...rest, error, type: "SESSION_EXPIRED" });
                    } else {
                      next({ ...rest, error, type: "NOT_AUTHORIZED" });
                    }
                  } else {
                    next({ ...rest, error, type: FAILURE });
                  }
                }
              );
            } else {
              next({ ...rest, result, type: SUCCESS });
            }
          },
          (error) => {
            if (error.status === 401) {
              if (error.message === "Session has expired") {
                next({ ...rest, error, type: "SESSION_EXPIRED" });
              } else {
                next({ ...rest, error, type: "NOT_AUTHORIZED" });
              }
            } else {
              if (
                FAILURE === "LOGIN_FAIL" &&
                error.status === 400 &&
                error.isClient
              ) {
                window.location.href = error.redirect;
              }
              next({ ...rest, error, type: FAILURE });
            }
          }
        )
        .catch((error) => {
          next({ ...rest, error, type: FAILURE });
        });
    };
  };
}
